import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProductTypeResponseInterface } from 'src/interfaces/product-type-response.interface';

@Injectable({
    providedIn: 'root',
})
export class TipoProductoApiService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    /** GET tipo-producto — listado de tipos de producto (pestañas de análisis masivo). */
    public getTiposProducto(): Observable<ProductTypeResponseInterface[]> {
        return this.http.get<ProductTypeResponseInterface[]>(
            `${this._apiUrl}tipo-producto`
        );
    }

    /** GET tipo-producto/especies — catálogo de especies (nutrición animal). */
    public getEspecies(): Observable<Array<{ id: number; nombre: string }>> {
        return this.http.get<Array<{ id: number; nombre: string }>>(
            `${this._apiUrl}tipo-producto/especies`
        );
    }

    /** Valores únicos de etapa_productiva en alimentos balanceados. */
    public getEtapasProductivas(): Observable<
        Array<{ id: number; nombre: string }>
    > {
        return this.http.get<Array<{ id: number; nombre: string }>>(
            `${this._apiUrl}tipo-producto/etapas-productivas`
        );
    }
}
